<!-- 智能图文推送管理 -->
<template>
  <div>
    <!-- 标题 -->
    <div class="page-title">智能图文推送管理</div>

    <div
      style="
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin: 10px 0 0;
      "
    >
      <div class="screen-box">
        <div class="screen-label">渠道</div>
        <a-select
          show-search
          allowClear
          style="min-width: 200px"
          placeholder="请选择渠道"
          @change="handleChangeB"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
        >
          <!-- <a-select-option
            v-for="(item, index) in bookList"
            :key="index"
            :value="item.key"
          >
            {{ item.label }}
          </a-select-option> -->
          <a-select-option
            v-for="(value, key) in searchSelect.channel"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </div>

      <div class="screen-box">
        <div class="screen-label">公众号</div>
        <gzhSearchMoreSelect
          @openGzhSelect="handleChangeA"
        ></gzhSearchMoreSelect>
        <!-- <a-select
          show-search
          allowClear
          notFoundContent="← 请先选择: 渠道"
          style="min-width: 200px"
          placeholder="请选择公众号"
          @change="handleChangeA"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
        >
          <a-select-option
            v-for="(value, key) in gzhSelect"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-select-option>
        </a-select> -->

        <!-- <moreSelect
          :gzhFilterData="gzhFilterData"
          :gzhFilterBlur="gzhFilterBlur"
          :gzhFilterSearch="gzhFilterSearch"
          :placeholder="'请选择公众号'"
          :select_mode="'multiple'"
          @handleChangeSelect="handleChangeA"
        ></moreSelect> -->
      </div>

      <div class="screen-box">
        <div class="screen-label">开启状态</div>
        <a-select
          show-search
          allowClear
          style="width: 180px"
          placeholder="请选择状态"
          @change="handleChangeD"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
        >
          <a-select-option :value="1">已开启</a-select-option>
          <a-select-option :value="0">已关闭</a-select-option>
        </a-select>
      </div>

      <div class="screen-box">
        <div class="screen-label">设置数量</div>
        <a-input-number id="inputNumber" v-model="r_num" :min="0" />
      </div>

      <div
        class="screen-box"
        v-if="role_control.includes(1) || role_control.includes(2)"
      >
        <div class="screen-label">管理员</div>
        <a-select
          showSearch
          style="min-width: 200px"
          placeholder="请选择管理员"
          @change="handleChangeG"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          allowClear
        >
          <a-select-option
            v-for="(value, key) in searchSelect.user"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </div>

      <a-button
        class="screen-box"
        @click="searchButton('button')"
        :loading="search_button_loading"
        type="primary"
        icon="search"
      >
        搜索
      </a-button>
    </div>

    <div>
      <!-- 表头 -->
      <div class="table-th" :style="{ width: table_scroll_width + 'px' }">
        <div v-for="(item, index) in rableTitle" :key="index">
          <div class="table-th-cell" :style="{ width: item.width + 'px' }">
            {{ item.title }}
          </div>
        </div>
      </div>

      <!-- 表格内容 -->
      <div
        v-for="(item, index) in tableShowData"
        :key="index"
        class="table-td"
        :style="{ width: table_scroll_width + 'px' }"
      >
        <template v-for="(z_tem, z_ndex) in rableTitle">
          <div
            :key="z_ndex"
            v-if="
              z_tem.type != 'cz' &&
              z_tem.type != 'new_user_imgtxt_button' &&
              z_tem.type != 'admin_user'
            "
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            {{ item[z_tem.type] }}
          </div>
          <div
            :key="z_ndex"
            v-else-if="z_tem.type == 'new_user_imgtxt_button'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            <!-- {{item[z_tem.type] == 1? '开启':'关闭'}} -->
            <a-switch
              :checked="item.new_switch"
              @change="newSwitchChange($event, item)"
              checked-children="开"
              un-checked-children="关"
              size="small"
            />
          </div>
          <div
            :key="z_ndex"
            v-else-if="z_tem.type == 'cz'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="display: flex"
          >
            <!-- <a-button size="small" style="margin-right:10px;">消息管理</a-button>
					<a-button size="small">推送数据</a-button> -->
            <div @click="wxTdCz(1, item)" class="cz-cell">消息管理</div>
            <div @click="wxTdCz(2, item)" class="cz-cell">推送数据</div>
          </div>
          <div
            v-else-if="z_tem.type == 'admin_user'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="display: flex"
          >
            <div class="div_text_name">
              {{ item.admin_user | formatAdminUser }}
            </div>
          </div>
        </template>
      </div>

      <!-- 表格内容为空时显示 -->
      <div
        v-show="tableShowData.length == 0"
        style="text-align: center; text-align: center; padding: 80px 0 50px"
        :style="{ width: table_null_width + 'px' }"
      >
        <a-icon style="font-size: 70px; color: #999" type="file-search" />
        <div style="color: #999; font-size: 16px; margin-top: 20px">
          内容为空
        </div>
        <!-- <div>说明： 默认选择 智能图文状态 ：已开启。</div> -->
      </div>
    </div>

    <!-- 分页 -->
    <pagingCompont
      :table_scroll_width="table_scroll_width"
      :table_null_width="table_null_width"
      :r_page="r_page"
      :r_limit="r_limit"
      :table_total="table_total"
      @pagination-Change="paginationChange"
    ></pagingCompont>

    <a-drawer
      title="推送数据"
      width="1300px"
      placement="right"
      :closable="false"
      :visible="visibleData"
      @close="drawerClose"
    >
      <div style="height: 100%; position: relative">
        <a-tabs :activeKey="drawer_content_type" @change="tabDrawerData">
          <a-tab-pane key="1" tab="推送统计"></a-tab-pane>
          <a-tab-pane key="2" tab="推送日志"></a-tab-pane>
        </a-tabs>

        <div v-show="drawer_content_type == '1'">
          <div style="display: flex">
            <div class="screen-box">
              <div class="screen-label">日期</div>
              <a-range-picker
                style="width: 300px"
                @change="onChangeDate"
                :allowClear="false"
                :locale="locale"
                :value="[
                  this.moment(startTime, dateFormat),
                  this.moment(endTime, dateFormat),
                ]"
              />
            </div>

            <a-button
              class="screen-box"
              @click="configSearch()"
              :loading="search_button_loading"
              type="primary"
              icon="search"
            >
              搜索
            </a-button>
          </div>

          <!-- 表头 -->
          <div class="table-th" :style="{ width: configTable_width + 'px' }">
            <div v-for="(item, index) in configTable" :key="index">
              <div
                class="table-th-cell"
                :style="{
                  width: item.width + 'px',
                  'justify-content': item.text_right ? 'flex-end' : '',
                }"
              >
                {{ item.title }}
              </div>
            </div>
          </div>

          <div
            v-for="(item, index) in configData"
            :key="index"
            class="table-td"
            :style="{ width: configTable_width + 'px' }"
          >
            <template v-for="(z_tem, z_ndex) in configTable">
              <div
                :key="z_ndex"
                v-if="z_tem.type != 'status' && z_tem.type != 'cz'"
                class="table-td-cell"
                :class="{ 'text-right': configTable[z_ndex].text_right }"
                :style="{ width: configTable[z_ndex].width + 'px' }"
              >
                {{ item[z_tem.type] }}
              </div>
              <div
                :key="z_ndex"
                v-else-if="z_tem.type == 'status'"
                class="table-td-cell"
                :class="{ 'text-right': configTable[z_ndex].text_right }"
                :style="{ width: configTable[z_ndex].width + 'px' }"
              >
                {{ item[z_tem.type] == 1 ? "开启" : "关闭" }}
              </div>
              <div
                :key="z_ndex"
                v-else-if="z_tem.type == 'cz'"
                @click="goLog(item)"
                class="table-td-cell"
                :class="{ 'text-right': configTable[z_ndex].text_right }"
                :style="{ width: configTable[z_ndex].width + 'px' }"
                style="cursor: pointer; color: rgb(47, 136, 255)"
              >
                推送日志
              </div>
            </template>
          </div>
          <!-- 表格内容为空时显示 -->
          <div
            v-show="configData.length == 0"
            style="text-align: center; text-align: center; padding: 80px 0 50px"
            :style="{ width: configTable_width + 'px' }"
          >
            <a-icon style="font-size: 70px; color: #999" type="file-search" />
            <div style="color: #999; font-size: 16px; margin-top: 20px">
              内容为空
            </div>
          </div>
          <!-- 分页 -->
          <pagingCompont
            :table_scroll_width="configTable_width"
            :table_null_width="configTable_width"
            :r_page="config_page"
            :r_limit="config_limit"
            :table_total="config_total"
            @pagination-Change="paginationConfig"
          ></pagingCompont>
        </div>

        <div v-show="drawer_content_type == '2'">
          <div style="display: flex">
            <div class="screen-box">
              <div class="screen-label">日期</div>
              <a-range-picker
                style="width: 300px"
                @change="onChangeDate_log"
                :allowClear="false"
                :locale="locale"
                :value="[
                  this.moment(log_startTime, dateFormat),
                  this.moment(log_endTime, dateFormat),
                ]"
              />
            </div>

            <div class="screen-box">
              <div class="screen-label">配置ID</div>
              <a-select
                show-search
                allowClear
                style="min-width: 350px"
                placeholder="请选择配置"
                @change="handleChangeP"
                :filter-option="filterOption"
                :getPopupContainer="getsPopupContainer"
                :value="log_id"
              >
                <a-select-option
                  v-for="(item, index) in configSelect"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.delay_text }} （配置ID：{{ item.id }}）
                </a-select-option>
              </a-select>
            </div>

            <a-button
              class="screen-box"
              @click="logSearch()"
              :loading="search_button_loading"
              type="primary"
              icon="search"
            >
              搜索
            </a-button>
          </div>
          <!-- 表头 -->
          <div class="table-th" :style="{ width: logTable_width + 'px' }">
            <div v-for="(item, index) in logTable" :key="index">
              <div
                class="table-th-cell"
                :style="{
                  width: item.width + 'px',
                  'justify-content': item.text_right ? 'flex-end' : '',
                }"
              >
                {{ item.title }}
              </div>
            </div>
          </div>

          <div
            v-for="(item, index) in logData"
            :key="index"
            class="table-td"
            :style="{ width: logTable_width + 'px' }"
          >
            <template v-for="(z_tem, z_ndex) in logTable">
              <div
                :key="z_ndex"
                v-if="z_tem.type != 'status'"
                class="table-td-cell"
                :class="{ 'text-right': logTable[z_ndex].text_right }"
                :style="{ width: logTable[z_ndex].width + 'px' }"
              >
                {{ item[z_tem.type] }}
              </div>
              <!-- <div v-else-if="z_tem.type == 'delay_text'" class="table-td-cell"
						:style="{'width':configTable[z_ndex].width + 'px'}">
							<span>用户关注后</span><br/>
							{{item[z_tem.type]}}
						</div> -->
              <!-- <div v-else-if="z_tem.type == 'date_key'" class="table-td-cell"
						:style="{'width':configTable[z_ndex].width + 'px'}">
							{{item[z_tem.type].substring(0,10)}}<br/>
							{{item[z_tem.type].substring(11)}}
						</div>
						<div v-else-if="z_tem.type == 'set_send_time'" class="table-td-cell"
						:style="{'width':configTable[z_ndex].width + 'px'}">
							{{item[z_tem.type].substring(0,10)}}<br/>
							{{item[z_tem.type].substring(11)}}
						</div>
						<div v-else-if="z_tem.type == 'server_send_time'" class="table-td-cell"
						:style="{'width':configTable[z_ndex].width + 'px'}">
							{{item[z_tem.type].substring(0,10)}}<br/>
							{{item[z_tem.type].substring(11)}}
						</div> -->
              <div
                :key="z_ndex"
                v-else-if="z_tem.type == 'status'"
                class="table-td-cell"
                :class="{ 'text-right': logTable[z_ndex].text_right }"
                :style="{ width: logTable[z_ndex].width + 'px' }"
              >
                {{ item[z_tem.type] | logData_status }}
                <!-- 失败的时候显示原因 -->
                <a-popover v-if="item[z_tem.type] == 2">
                  <template slot="content">
                    <div>失败原因：{{ item["remark"] }}</div>
                  </template>
                  <a-icon
                    type="question-circle"
                    theme="filled"
                    style="margin-left: 5px; cursor: pointer"
                  />
                </a-popover>
              </div>
            </template>
          </div>
          <!-- 表格内容为空时显示 -->
          <div
            v-show="logData.length == 0"
            style="text-align: center; text-align: center; padding: 80px 0 50px"
            :style="{ width: logTable_width + 'px' }"
          >
            <a-icon style="font-size: 70px; color: #999" type="file-search" />
            <div style="color: #999; font-size: 16px; margin-top: 20px">
              内容为空
            </div>
          </div>
          <!-- 分页 -->
          <pagingCompont
            :table_scroll_width="logTable_width"
            :table_null_width="logTable_width"
            :r_page="log_page"
            :r_limit="log_limit"
            :table_total="log_total"
            @pagination-Change="paginationLog"
          ></pagingCompont>
        </div>

        <div
          style="
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 9;
          "
          v-show="drawer_search_loading"
        >
          <a-spin size="large" />
        </div>
      </div>
    </a-drawer>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import moreSelect from "@/components/selectCompont/moreSelect.vue";
import gzhSearchMoreSelect from "@/components/selectCompont/searchSelect.vue";
import {
  imgtxtList,
  wxMaterialSelect,
  opeGzhSelect,
  putDataMenu,
  imgtxtLog,
  imgtxtMsgList,
  imgtxtGzhSwitch,
} from "@/request/api";
export default {
  name: "imgTextPush_",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    moreSelect,
    gzhSearchMoreSelect,
  },
  data() {
    this.dateFormat = "YYYY-MM-DD";
    return {
      locale,
      moment,
      startTime: "2022-06-12",
      endTime: "2022-06-23",
      log_startTime: "2022-06-12",
      log_endTime: "2022-06-23",

      // 表格部分内容
      // 表格的表头，规定宽度和要用的其他信息
      rableTitle: [
        { title: "公众号ID", width: 100, type: "id" },
        { title: "公众号名称", width: 130, type: "gzh_name" },
        { title: "渠道", width: 150, type: "channel_name" },
        { title: "开启状态", width: 110, type: "new_user_imgtxt_button" },
        { title: "设置数量", width: 110, type: "imgtxt_count" },
        { title: "操作", width: 180, type: "cz" },
        { title: "关联投放公众号ID", width: 120, type: "put_gzh_id" },
        { title: "管理员", width: 120, type: "admin_user" },
      ],
      tableShowData: [],
      table_scroll_width: 1000,
      table_null_width: 1000,

      search_button_loading: false,

      r_page: 1, // 页数
      r_limit: 30, // 每页多少条
      table_total: 0, // 表格内容总数

      r_new_user_imgtxt_button: undefined, // 是否开启智能图文0=否，1=是
      r_channel_id: undefined, // 渠道
      r_gzh_id: undefined, // 公众号
      r_admin_id: undefined, // 管理员
      r_num: null, // 数量

      bookList: [], // 渠道下拉
      gzhSelect: [], // 公众号下拉

      searchSelect: [{}], // 渠道，公众号 下拉框数据

      // 筛选条件部分
      filterData: {
        channel_id: {
          list: [{}],
        },
        gzh_id: {
          list: [{}],
        },
      }, // 筛选条件数组

      // 公众号下拉框-带下滑加载-带搜索
      gzhFilterData: [], // 公众号下拉选择框的数据
      gzhFilterBlur: [], // 保存一份，用于失去焦点后，回复原来的数值
      gzhFilterSearch: [], // 下拉框搜索后的存放数据
      gzh_page: 0,
      gzh_limit: 50,
      // 公众号下拉框-结束

      visibleData: false,

      configTable: [
        // 推送统计
        { title: "配置ID", width: 70, type: "id", text_right: false },
        {
          title: "延迟时间",
          width: 170,
          type: "delay_text",
          text_right: false,
        },
        { title: "日期", width: 150, type: "date_key", text_right: false },
        { title: "操作", width: 100, type: "cz", text_right: false },
        {
          title: "成功推送次数",
          width: 100,
          type: "success_send",
          text_right: true,
        },
        {
          title: "包含用户数",
          width: 100,
          type: "server_send_success",
          text_right: true,
        },
        {
          title: "微信预送达用户数",
          width: 120,
          type: "filter_count",
          text_right: true,
        },
        {
          title: "微信成功数",
          width: 100,
          type: "success_openid_count",
          text_right: true,
        },
        {
          title: "微信失败数",
          width: 100,
          type: "fail_openid_count",
          text_right: true,
        },
        {
          title: "推送失败次数",
          width: 100,
          type: "fail_send",
          text_right: true,
        },
        {
          title: "包含用户数",
          width: 100,
          type: "server_fail_count",
          text_right: true,
        },
      ],
      configTable_width: 1000, // 表格宽度
      configData: [],
      config_page: 1,
      config_limit: 20,
      config_total: 0,
      config_id: null,
      configSelect: [], // 用于下拉框的数据
      // config_search_loading: false,

      logTable: [
        // 推送日志
        { title: "配置ID", width: 70, type: "config_id", text_right: false },
        {
          title: "延迟时间",
          width: 160,
          type: "delay_text",
          text_right: false,
        },
        { title: "打包时间", width: 150, type: "date_key", text_right: false },
        {
          title: "预设推送时间",
          width: 150,
          type: "set_send_time",
          text_right: false,
        },
        {
          title: "实际推送时间",
          width: 150,
          type: "server_send_time",
          text_right: false,
        },
        { title: "推送状态", width: 90, type: "status", text_right: false },
        {
          title: "包含用户数",
          width: 90,
          type: "openid_count",
          text_right: true,
        },
        {
          title: "微信预送达数",
          width: 100,
          type: "filter_count",
          text_right: true,
        },
        {
          title: "微信成功数",
          width: 90,
          type: "success_count",
          text_right: true,
        },
        {
          title: "微信失败数",
          width: 90,
          type: "fail_count",
          text_right: true,
        },
      ],
      logTable_width: 1000, // 表格宽度
      logData: [],
      log_id: null,
      log_page: 1,
      log_limit: 20,
      log_total: 0,

      drawer_content_type: "1",
      drawer_search_loading: false,

      role_control: [], // 用户权限控制
    };
  },
  mounted() {
    let that = this;
    that.search_button_loading = true;

    // 获取角色权限
    that.role_control = JSON.parse(localStorage.getItem("role_limits"));

    // 获取当前日期
    let date2 = new Date();
    let month2;
    if (date2.getMonth() + 1 < 10) {
      month2 = "0" + (date2.getMonth() + 1);
    } else {
      month2 = date2.getMonth() + 1;
    }
    let day2;
    if (date2.getDate() < 10) {
      day2 = "0" + date2.getDate();
    } else {
      day2 = date2.getDate();
    }
    that.endTime = date2.getFullYear() + "-" + month2 + "-" + day2;
    that.startTime = that.endTime;
    that.log_startTime = that.endTime;
    that.log_endTime = that.endTime;

    // 获取表格信息
    let body_width = document.body.clientWidth - 60 - 50 - 190; // 筛选条件大盒子的宽度
    let nn = 0;
    that.rableTitle.forEach((res) => {
      nn = nn + res.width;
    });
    let table_width = 0;
    // 表格宽度小于屏幕的可视宽度减去两边的内边距，并且差距要在100px以上
    if (nn < body_width && body_width - nn > 50) {
      // 当表格内容不足以沾满一屏时，要适配成一屏
      // console.log("适配")
      that.rableTitle.forEach((res) => {
        // 针对表格每一项的宽度进行适配
        res.width = Math.round((res.width / nn) * body_width); // 这里减是为了避免res.width值的总和会超过body_width进行的微调，不-10问题应该也不大
      });
      table_width = body_width;
    } else {
      // 表格宽度大于等于屏幕可视宽度
      // console.log("不适配")
      table_width = nn;
    }
    that.table_scroll_width = table_width;
    that.table_null_width = table_width;
    table_width = body_width;

    // 推送统计
    let fff = 0;
    that.configTable.forEach((res) => {
      fff = fff + res.width;
    });
    that.configTable_width = fff;

    let lll = 0;
    that.logTable.forEach((res) => {
      lll = lll + res.width;
    });
    that.logTable_width = lll;

    opeGzhSelect().then((res) => {
      // console.log("获取渠道、管理员选择",res);
      that.searchSelect = res.data.data;
    });

    putDataMenu()
      .then((res) => {
        // console.log("putDataMenu",res.data.data.filter)
        that.filterData = res.data.data.filter;

        that.gzhFilterBlur = that.filterData.gzh_id.list || [];
        that.gzhFilterSearch = that.filterData.gzh_id.list || [];
        that.gzhFilterData =
          that.gzhFilterSearch.slice(that.gzh_page, that.gzh_limit) || [];
      })
      .catch(() => {
        // this.search_button_loading = false
      });

    // materialChannelSelect().then(res=>{
    // 	// console.log("下拉",res);
    // 	that.selectData = res.data.data
    // 	let c_data = res.data.data.channel
    // 	let show_data = []
    // 	for (let key in c_data) {
    // 		let ooo = {
    // 			key,
    // 			label: c_data[key],
    // 			status: false,
    // 		}
    // 		show_data.push(ooo)
    // 	}
    // 	// show_data[0].status = true
    // 	that.bookList = show_data

    // })

    // 修改母页面的tab高亮状态
    setTimeout(() => {
      that.$bus.$emit("tabPath", that.$route.fullPath);
    }, 300);

    that.searchButton();
  },
  methods: {
    // 日期选择
    onChangeDate(date, dateString) {
      // console.log(date, dateString);
      this.startTime = dateString[0];
      this.endTime = dateString[1];
    },
    // 日期选择
    onChangeDate_log(date, dateString) {
      // console.log(date, dateString);
      this.log_startTime = dateString[0];
      this.log_endTime = dateString[1];
    },
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 公众号
    handleChangeA(value) {
      // console.log('1',value)
      this.r_gzh_id = value;
    },
    // 书城
    handleChangeB(e) {
      this.r_channel_id = e;
      // this.search_button_loading = true
      // this.getGzhSelect(e)
    },
    // 状态
    handleChangeD(e) {
      this.r_new_user_imgtxt_button = e;
    },
    // 请选择管理员
    handleChangeG(e) {
      this.r_admin_id = e;
    },
    // 选择配置ID
    handleChangeP(e) {
      console.log(e);
      this.log_id = e;
    },

    // 根据渠道获取公众号
    getGzhSelect(e) {
      let that = this;
      wxMaterialSelect({
        channel_id: e,
      }).then((res) => {
        that.search_button_loading = false;

        if (res.data.code == 401) {
          // 未登录
          localStorage.removeItem("access_token");
          that.$router.replace({ name: "login", params: { type: "not_log" } });
          return;
        }

        console.log("根据渠道获取公众号", res);
        that.gzhSelect = res.data.data.list;
      });
    },

    // 搜索
    searchButton(type) {
      let that = this;
      that.search_button_loading = true;

      if (type == "button") {
        that.r_page = 1;
      }

      let r_data = {
        page: that.r_page,
        limit: that.r_limit,
        new_user_imgtxt_button: that.r_new_user_imgtxt_button, // 状态
        channel_id: that.r_channel_id, // 书城
        gzh_id: that.r_gzh_id, // 公众号
        admin_id: that.r_admin_id, // 管理人员
        num: that.r_num, // 数量
      };

      imgtxtList(r_data).then((res) => {
        console.log("imgtxtList", res);
        that.search_button_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("搜索成功");
          that.table_total = res.data.data.total;
          let data = res.data.data.data;
          data.forEach((res) => {
            if (res.new_user_imgtxt_button == 1) {
              res.new_switch = true;
            } else {
              res.new_switch = false;
            }
          });
          that.tableShowData = res.data.data.data;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`其他错误：${res.data.msg}`);
          }
        }
      });
    },
    // 分页
    paginationChange(e) {
      this.r_page = e;
      this.searchButton();
    },
    paginationConfig(e) {
      this.config_page = e;
      this.configSearch();
    },
    paginationLog(e) {
      this.log_page = e;
      this.logSearch();
    },
    // 推送统计
    configSearch() {
      let that = this;
      that.search_button_loading = true;
      // 推送统计
      imgtxtMsgList({
        gzh_id: that.config_id,
        page: that.config_page,
        limit: that.config_limit,
        start_time: that.startTime.replace(/-/g, ""),
        end_time: that.endTime.replace(/-/g, ""),
        order: "delay_time",
        sort: "asc",
      }).then((res) => {
        console.log("推送统计", res);
        that.search_button_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          // that.$message.success('搜索成功');
          let data = res.data.data.data;
          data.forEach((res) => {
            if (res.delay_type === 2) {
              let imgText_hour = Math.floor(res.delay_time / 60);
              let imgText_minute = res.delay_time - imgText_hour * 60;
              let curHour = String(imgText_hour).padStart(2, "0");
              let curMinute = String(imgText_minute).padStart(2, "0");

              if (res.delay_day) {
                res.delay_text = `用户关注后第${res.delay_day}天${curHour}:${curMinute}`;
              } else {
                res.delay_text = `用户关注当天${curHour}:${curMinute}`;
              }
            } else {
              if (res.delay_time < 60) {
                res.delay_text = "用户关注后" + res.delay_time + "分钟";
              } else {
                let hhh = Math.floor(res.delay_time / 60);
                let mmm = res.delay_time - hhh * 60;

                if (mmm) {
                  res.delay_text = "用户关注后" + hhh + "小时" + mmm + "分钟";
                } else {
                  res.delay_text = "用户关注后" + hhh + "小时";
                }
              }
            }
          });
          that.configData = res.data.data.data;
          that.config_total = res.data.data.total;
          that.visibleData = true;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    // 推送日志
    logSearch() {
      let that = this;
      that.search_button_loading = true;
      // 推送统计
      imgtxtLog({
        gzh_id: that.config_id,
        config_id: that.log_id,
        page: that.log_page,
        limit: that.log_limit,
        start_time: that.log_startTime.replace(/-/g, ""),
        end_time: that.log_endTime.replace(/-/g, ""),
        order: "delay_time",
        sort: "asc",
      }).then((res) => {
        console.log("推送日志", res);
        that.search_button_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          // that.$message.success('搜索成功');
          let data = res.data.data.data;
          data.forEach((res) => {
            if (res.delay_type === 2) {
              let imgText_hour = Math.floor(res.delay_time / 60);
              let imgText_minute = res.delay_time - imgText_hour * 60;
              let curHour = String(imgText_hour).padStart(2, "0");
              let curMinute = String(imgText_minute).padStart(2, "0");
              if (res.delay_day) {
                res.delay_text = `用户关注后第${res.delay_day}天${curHour}:${curMinute}`;
              } else {
                res.delay_text = `用户关注后当天${curHour}:${curMinute}`;
              }
            } else {
              if (res.delay_time < 60) {
                res.delay_text = "用户关注后" + res.delay_time + "分钟";
              } else {
                let hhh = Math.floor(res.delay_time / 60);
                let mmm = res.delay_time - hhh * 60;
                if (mmm) {
                  res.delay_text = "用户关注后" + hhh + "小时" + mmm + "分钟";
                } else {
                  res.delay_text = "用户关注后" + hhh + "小时";
                }
              }
            }
          });
          that.logData = res.data.data.data;
          that.log_total = res.data.data.total;
          // that.visibleData = true
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },

    // 表格内的操作
    wxTdCz(e, item) {
      console.log("item", item);
      let that = this;
      if (e == 1) {
        // 消息管理
        const { href } = this.$router.resolve({
          path: "/imgTextMessage",
          query: { j_gzh_id: item.id, j_gzh_name: item.gzh_name },
        });
        window.open(href, "_blank");
        // this.$router.push({ path:'/imgTextMessage',query:{ j_gzh_id: item.id, j_gzh_name: item.gzh_name }})
      } else if (e == 2) {
        // 推送数据
        that.config_id = item.id;
        that.configSearch();
        // 推送统计，用于推送日志的配置ID下拉框
        imgtxtMsgList({
          gzh_id: that.config_id,
          page: that.config_page,
          limit: 10000,
          order: "delay_time",
          sort: "asc",
        }).then((res) => {
          // console.log("推送统计",res)
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            // that.$message.success('搜索成功');
            let data = res.data.data.data;
            data.forEach((res) => {
              if (res.delay_type === 2) {
                let imgText_hour = Math.floor(res.delay_time / 60);
                let imgText_minute = res.delay_time - imgText_hour * 60;
                let curHour = String(imgText_hour).padStart(2, "0");
                let curMinute = String(imgText_minute).padStart(2, "0");
                if (res.delay_day) {
                  res.delay_text = `用户关注后第${res.delay_day}天${curHour}:${curMinute}`;
                } else {
                  res.delay_text = `用户关注后当天${curHour}:${curMinute}`;
                }
              } else {
                if (res.delay_time < 60) {
                  res.delay_text = "用户关注后" + res.delay_time + "分钟";
                } else {
                  let hhh = Math.floor(res.delay_time / 60);
                  let mmm = res.delay_time - hhh * 60;
                  if (mmm) {
                    res.delay_text = "用户关注后" + hhh + "小时" + mmm + "分钟";
                  } else {
                    res.delay_text = "用户关注后" + hhh + "小时";
                  }
                }
              }
            });
            that.configSelect = res.data.data.data;
          }
        });
      }
    },

    // 推送数据侧边栏的tab切换
    tabDrawerData(e) {
      // console.log(e)
      this.drawer_content_type = e;
      if (e == "2") {
        this.logSearch();
      }
    },
    // 推送数据侧边栏
    drawerClose() {
      this.visibleData = false;
    },
    // 查看推送日志
    goLog(item) {
      console.log("item", item);
      this.log_id = item.id;
      this.drawer_content_type = "2";
      this.logSearch();
    },

    // 开启关闭操作
    newSwitchChange(e, item) {
      console.log(e, item);
      imgtxtGzhSwitch({
        id: item.id,
      }).then((res) => {
        console.log("开关", res);
        if (res.data.code == 401) {
          // 未登录
          localStorage.removeItem("access_token");
          this.$router.replace({ name: "login", params: { type: "not_log" } });
          return;
        }
        item.new_switch = !item.new_switch;
      });
    },
  },
  filters: {
    logData_status(value) {
      let vvv = "";
      if (value == 0) {
        vvv = "待发送";
      } else if (value == 1) {
        vvv = "成功";
      } else if (value == 2) {
        vvv = "失败";
      }
      return vvv;
    },
    formatAdminUser(val) {
      const userList = [];
      if (Object.keys(val).length > 0) {
        for (const key in val) {
          userList.push(val[key]);
        }
        return userList.join(", ");
      }
      return "";
    },
  },
};
</script>

<style scoped>
/* .table-td-cell {
	font-size: 14px;
} */
/* 表格内的操作按钮 */
.cz-cell {
  color: #62a8ea;
  cursor: pointer;
  margin-right: 12px;
  /* margin-bottom: 5px; */
}
.cz-cell:hover {
  color: rgb(47, 136, 255);
}
</style>
